export const NEW_RELIC_OWNER = 'checkout';
